import { useState, useEffect } from 'react';
import { ScheduleDate } from '../entities/ScheduleDate';
import { ScheduleValidator } from '../services/ScheduleValidator';

export const useSchedulePickerController = (initialDate: Date) => {
  const [selected, setSelectedState] = useState(new ScheduleDate(initialDate));
  const [isValid, setIsValid] = useState(ScheduleValidator.isFuture(selected));

  const setSelected = (date: ScheduleDate) => {
    setSelectedState(date);
    setIsValid(ScheduleValidator.isFuture(date));
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setIsValid(ScheduleValidator.isFuture(selected));
    }, 1000);

    return () => clearInterval(interval);
  }, [selected]);

  return {
    selected,
    isValid,
    setSelected,
  };
};
